$(document).ready(function () {
    let $bi = $('#branch-banner-iframe');

    //Temporary fix for detecting ipad on ios 13+
    let iPad =
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream);

    if (CBS.Registry.platform.isHandheld === 1 || iPad === true) {
        let body = $('body');
        let count = 0;
        let journey = 'open';

        var journeyCloseHandler = function (event, data) {
            body.css({ 'margin-top': '96px' });
            journey = 'closed';
            clearInterval(t);
        };

        let t = setInterval(function () {
            if ($bi.length === 0) {
                $bi = $('#branch-banner-iframe');
            }

            if ($bi.length > 0 && journey == 'open') {
                //listens for when journey is closed.
                branch.addListener('didClickJourneyClose', journeyCloseHandler);

                $bi.position().top <= 0
                    ? body.css({ 'margin-top': $bi.height() + 'px' })
                    : body.css({ 'margin-top': '0' });
                clearInterval(t);

                $(window).resize(function () {
                    setTimeout(function () {
                        if ($bi.length > 0 && journey == 'open') {
                            $bi.position().top <= 0
                                ? body.css({ 'margin-top': $bi.height() + 'px' })
                                : body.css({ 'margin-top': '0' });
                        }
                    }, 250);
                });
            }
            count++;

            if (count >= 10) {
                clearInterval(t);
            }
        }, 500);
    }
});
